import { useLang } from "@/lib/lang";
import { Star, Quote } from "lucide-react";
import { avatarFor } from "@/lib/constants";

export default function Testimonials() {
  const { t } = useLang();
  return (
    <section id="stories" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="max-w-3xl">
          <div className="section-eyebrow">Real people, real results</div>
          <h2 className="mt-3 font-display text-4xl md:text-5xl" style={{ color: "var(--primary)" }}>{t.testimonials.title}</h2>
        </div>
        <div className="mt-12 flex gap-5 overflow-x-auto snap-x snap-mandatory no-scrollbar pb-4 -mx-5 px-5">
          {t.testimonials.list.map((r, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="min-w-[320px] md:min-w-[420px] snap-start card-soft p-8 relative"
            >
              <Quote size={28} style={{ color: "var(--yellow-deep)" }} />
              <p className="mt-4 text-base leading-relaxed" style={{ color: "var(--text-primary)" }}>{r.text}</p>
              <div className="mt-6 flex items-center gap-3">
                <img
                  src={avatarFor(r.name)}
                  alt={r.name}
                  className="w-12 h-12 rounded-full object-cover border-2"
                  style={{ borderColor: "var(--primary)" }}
                />
                <div>
                  <div className="font-bold" style={{ color: "var(--primary)" }}>{r.name}</div>
                  <div className="text-xs" style={{ color: "var(--text-secondary)" }}>{r.city}</div>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: r.stars }).map((_, s) => (
                    <Star key={s} size={14} fill="#FBC531" stroke="#14142B" strokeWidth={1} />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
